/**
 * "Host your app starting ₹150 per month*" (plan D10) — highlighted, and the
 * whole callout links to the public Hosting prices page. The figure is the
 * cheapest hosting option in the Marketplace policy (GET /build/hosting), never
 * a literal. Shown wherever a monthly price to use a built app appears.
 */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { money } from '@/api/marketplace'
import { getHosting, type HostingPrices } from '@/api/marketplaceBuild'

const cache: Record<string, Promise<HostingPrices>> = {}

export function useHosting(currency = 'INR'): HostingPrices | null {
  const [h, setH] = useState<HostingPrices | null>(null)
  useEffect(() => {
    cache[currency] = cache[currency] || getHosting(currency)
    cache[currency].then(setH).catch(() => { delete cache[currency]; setH(null) })
  }, [currency])
  return h
}

export default function HostCallout({ currency = 'INR', size = 'md' }: { currency?: string; size?: 'md' | 'lg' }) {
  const h = useHosting(currency)
  if (!h || !h.start.amount_minor) return null
  const perPerson = h.start.basis === 'person'
  const big = size === 'lg'
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignSelf: 'flex-start' }}>
      <Link to="/marketplace/hosting" className="mkt-hostcta" style={big ? { fontSize: 20, padding: '14px 26px' } : undefined}>
        <svg aria-hidden="true" width={big ? 26 : 20} height={big ? 26 : 20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="7" rx="2" /><rect x="3" y="13" width="18" height="7" rx="2" /><path d="M7 7.5h.01M7 16.5h.01" /></svg>
        <span>Host your app starting <strong>{money(h.start.amount_minor, h.currency)} per month*</strong></span>
        <span aria-hidden="true">→</span>
      </Link>
      <span className="mkt-faint">*{perPerson ? 'Per person, before GST.' : 'Before GST.'} See all hosting prices.</span>
    </div>
  )
}
